/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HangarGroupPublic,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary HangarGroup list
 */
export const publicHangarGroups = (
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      username = toValue(username);

      return axiosClient<HangarGroupPublic[]>(
      {url: `/public/hangars/${username}/groups`, method: 'GET', signal
    },
      );
    }




export const getPublicHangarGroupsQueryKey = (username: MaybeRefOrGetter<string>,) => {
    return [
    'public','hangars',username,'groups'
    ] as const;
    }


export const getPublicHangarGroupsQueryOptions = <TData = Awaited<ReturnType<typeof publicHangarGroups>>, TError = ErrorType<SchemaValidationErrorResponse>>(username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarGroups>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicHangarGroupsQueryKey(username);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicHangarGroups>>> = ({ signal }) => publicHangarGroups(username, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicHangarGroups>>, TError, TData>
}

export type PublicHangarGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof publicHangarGroups>>>
export type PublicHangarGroupsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary HangarGroup list
 */

export function usePublicHangarGroups<TData = Awaited<ReturnType<typeof publicHangarGroups>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicHangarGroups>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicHangarGroupsQueryOptions(username,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






